import { render, staticRenderFns } from "./IdentifyBrowser.vue?vue&type=template&id=6b5454a3&scoped=true&"
import script from "./IdentifyBrowser.vue?vue&type=script&lang=js&"
export * from "./IdentifyBrowser.vue?vue&type=script&lang=js&"
import style0 from "./IdentifyBrowser.vue?vue&type=style&index=0&id=6b5454a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5454a3",
  null
  
)

export default component.exports